export const SET_LOADING = "set-loading";
export const SET_INVITES = "set-invites";
export const INCREASE_PAGE = "increase-page";
export const DECREASE_PAGE = "decrease-page";
export const SET_IS_NEXT_PAGE = "set-is-next-page";
export const SET_SEARCH_TERM = "set-search-term";
export const RESET_INVITE_MODULE = "reset-invite-module";
